import type { LanguageItem } from '../../types';
import { checkSameLanguages } from '../../utils/check-same-languages';

export function getSiteLanguage(languages: LanguageItem[] | null) {
  const documentLang = document.documentElement.lang;

  if (!documentLang) {
    return;
  }

  const finalLang = checkSameLanguages(documentLang);
  const isLangWithoutRegion = !documentLang.includes('-');
  if (isLangWithoutRegion) {
    const derivedDocumentLang = (languages ?? []).find(({ language }) => {
      const [languageWithoutRegion] = language.split('-');

      return languageWithoutRegion === documentLang;
    })?.language;

    return derivedDocumentLang ?? finalLang;
  }

  return finalLang;
}
